import { sortField } from '../../components/ManagedDataTable/interfaces';

export enum Status {
  OPEN = 'open',
  SUCCESS = 'success',
  FAILED = 'failed',
}

export type Stage = {
  id: number;
  name: string;
  color: string;
  order: number;
  items?: Item[];
};

export type Client = {
  id: number;
  name: string;
};

export type Product = {
  id: number;
  name: string;
};

export type Agent = {
  id: number;
  firstName: string;
  lastName: string;
  avatar: string;
};

export type Contact = {
  id: number;
  firstName: string;
  lastName: string;
};

export type Item = {
  id: number;
  title: string;
  client: Client;
  product: Product;
  agent: Agent;
  contact: Contact;
  stage: Stage;
  createdAt: string;
  status: Status;
  closedAt?: string;
  closedBy?: Agent;
  reason?: string;
};

export interface IGetStagesResponse {
  data: Stage[];
}

export interface IUpdateItemParams {
  stageId?: number;
  clientId?: number;
  contactId?: number;
  agentId?: number;
  productId?: number;
  title?: string;
}

export interface ICreateItemParams {
  stageId: number;
  clientId: number;
  contactId: number;
  agentId: number;
  productId: number;
}

export interface ICloseItemParams {
  reason?: number;
  result: 'success' | 'failed';
}

export type OpportunitiesSort = sortField & {
  field: 'createdAt';
};
